<template>
  <div class="mc-filter-report-scheduler">
    <h4 class="my-3">
      {{ title }}
    </h4>
    <p>{{ $t('report.text.descFilterReportScheduler') }}</p>
    <b-card class="border">
      <b-card-body class="p-0 my-3">
        <div v-if="this.report.filter && isLoadFilter">
          <div class="my-2">
            <h5>{{ $t('report.object.parameterReport') }}</h5>
            <span>{{ $t('report.text.parameterFilterDesc') }}</span>
            <b-form-group v-if="hasReportTypeFilter">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label>{{ $t('report.object.reportType.title') }}</label>
                </div>
              </template>
              <b-form-radio v-model="reportType" value="weekly" class="me-2">
                <label class="radio-label">{{ $t('report.object.reportType.weekly') }}</label>
              </b-form-radio>
              <b-form-radio v-model="reportType" value="monthly" class="me-2">
                <label class="radio-label">{{ $t('report.object.reportType.monthly') }}</label>
              </b-form-radio>
            </b-form-group>
            <div v-if="isReportTypeRequired" class="ms-1 mt-1 fst-italic">
              <span class="text-danger">*</span> {{ $t('report.filters.required') }}
            </div>
            <FormulateForm v-model="formValues" ref="formRef" class="my-1" :key="formKey">
              <InputTableFilter
                :formValues="formValues"
                :fullObjects="fullObjects"
                @update:formValues="updateFormValues($event)"
                @update:fullObjects="updateFullObjects($event)"
                :report="finalReport"
              />
            </FormulateForm>
            <b-form-group
              v-if="hasIntervalFilter"
              id="interval-column"
              label-for="periode"
              class="p-1"
            >
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label>{{ $t('report.object.intervalData') }}</label>
                  <span v-b-tooltip.topleft :title="$t('report.object.intervalTooltip')">
                    <i class="icon-outline_info"></i>
                  </span>
                </div>
              </template>
              <div class="mc-modal__filter-button-group">
                <template v-for="item in listInterval">
                  <button
                    :key="`${item.key}-${report.key}`"
                    type="button"
                    :class="{
                      'mc-modal__filter-button--active': intervalData[item.key] && !item.disabled,
                      'mc-modal__filter-button': !item.disabled,
                      'mc-modal__filter-button--disabled': item.disabled,
                    }"
                    @click="filterIntervalData(item.key)"
                    :disabled="item.disabled"
                  >
                    {{ $t(item.label) }}
                  </button>
                </template>
              </div>
            </b-form-group>
            <b-form-group v-if="hasIsImportantFilter" id="important-alert" class="p-1">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label>{{ $t('report.object.isImportantFilter') }}</label>
                </div>
              </template>
              <span class="d-flex gap-2 w-100">
                <McCheckbox v-model="isImportant" />
                {{ $t('report.object.isImportant') }}
              </span>
            </b-form-group>
            <b-form-group v-if="hasFalseAlert" id="interval-column" label-for="periode" class="p-1">
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label>{{ $t('report.object.showAlert') }}</label>
                </div>
              </template>
              <div class="d-flex align-items-center">
                <b-form-radio v-model="falseAlert" :value="null" class="me-2">
                  <label class="radio-label">{{ $t('report.object.falseAlert.all') }}</label>
                </b-form-radio>
                <b-form-radio v-model="falseAlert" :value="false" class="me-2">
                  <label class="radio-label">{{
                    $t('report.object.falseAlert.notFalseAlert')
                  }}</label>
                </b-form-radio>
                <b-form-radio v-model="falseAlert" :value="true" class="me-2">
                  <label class="radio-label">{{
                    $t('report.object.falseAlert.onlyFalseAlert')
                  }}</label>
                </b-form-radio>
              </div>
              <McAlert variant="info" :text="$t('report.text.falseAlertdesc')" withIcon />
            </b-form-group>
          </div>
          <hr />
        </div>

        <div class="my-2">
          <h5>{{ $t('report.object.documentFormat') }}</h5>
          <span>{{ $t('report.text.documentFormatDesc') }}</span>
          <b-row class="mt-3">
            <span class="required">{{ $t('report.object.chooseFormat') }}</span>
          </b-row>
          <multiselect
            class="mt-2"
            track-by="value"
            label="label"
            v-model="downloadAs"
            :options="downloadOptions"
            :show-labels="false"
            :disabled="!formFilled"
          >
            <template #singleLabel="props">
              <i :class="`option__image pe-2 mc-fa ${props.option.icon}`"></i>
              <span class="option__title">{{ props.option.label }}</span>
            </template>
            <template #option="props">
              <i :class="`option__image pe-2 mc-fa ${props.option.icon}`"></i>
              <span class="option__title">{{ props.option.label }}</span>
            </template>
          </multiselect>
          <b-row v-if="!stateDownloadAs">
            <span class="text-danger text-sm-italic ms-1">{{
              $t('global.validation.required')
            }}</span>
          </b-row>
        </div>

        <hr />

        <div class="wrapper p-2 table-view-manager">
          <div class="section section-information">
            <p class="mc-general__label">{{ $t('global.viewSet.desc') }}</p>
            <div class="section-information__content p-2">
              <p>
                {{ $t('global.viewSet.click') }} <McCheckbox v-model="alwaysChecked" />
                {{ $t('global.viewSet.display') }}
              </p>
              <p>
                {{ $t('global.viewSet.click') }} <i class="icon-outline_move"></i>
                {{ $t('global.viewSet.move') }}
              </p>
            </div>
          </div>
          <div class="section section-column-manager">
            <p class="mc-general__label">{{ $t('global.viewSet.columnSettings') }}</p>
            <div class="section-column-manager__content">
              <div
                :class="`section-column-manager__header d-flex justify-content-${
                  max ? 'end' : 'between'
                } p-3`"
              >
                <div class="d-flex gap-2" v-if="!max">
                  <McCheckbox
                    @change="handleChangeCheckAll"
                    v-model="showAllColumn"
                    :disabled="isAnyLocked"
                  />
                  <span>{{ $t('global.viewSet.displayAll') }}</span>
                </div>
                <button @click="handleResetColumn">{{ $t('global.resetAsset') }}</button>
              </div>
              <draggable v-model="fieldsTemp" class="section-column-manager__draggable mb-3">
                <transition-group tag="ul">
                  <li
                    class="section-column-manager__draggable-item"
                    v-for="(field, index) in fieldsTemp"
                    :key="`${index}-${field.key}`"
                    :disabled="disabledCheck(field)"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center gap-2">
                        <i class="icon-outline_move" v-if="!field.isSticky"></i>
                        <div class="__divider" v-if="!field.isSticky"></div>
                        <span class="d-flex gap-2 w-100">
                          <McCheckbox
                            v-model="field.shown"
                            :disabled="disabledCheck(field)"
                            @change="
                              ($event) => handleChangeParentCheckbox({ field, value: $event })
                            "
                          />
                          {{ $t(field.label) }}
                        </span>
                      </div>
                      <div
                        class="mc-hover-pointer"
                        v-if="
                          (field.refreshAccordion == undefined || field.refreshAccordion) &&
                          refreshAccordion
                        "
                      >
                        <i
                          v-if="field.children && !field.closeChild"
                          class="toggle-list icon-outline_chevron-down"
                          @click="hideChildren(field)"
                        ></i>
                        <i
                          v-if="field.children && field.closeChild"
                          class="toggle-list icon-outline_chevron-up"
                          @click="hideChildren(field)"
                        ></i>
                      </div>
                    </div>

                    <template v-if="field.children && !field.closeChild">
                      <hr />

                      <draggable v-model="field.children">
                        <transition-group tag="ul">
                          <li
                            v-for="item in field.children"
                            :key="item.key"
                            class="section-column-manager__draggable-sub-item"
                          >
                            <div class="d-flex align-items-center gap-2">
                              <i class="icon-outline_move" v-if="!item.isSticky"></i>
                              <div class="__divider" v-if="!item.isSticky"></div>
                              <span class="d-flex gap-2 w-100">
                                <McCheckbox
                                  v-model="item.shown"
                                  :disabled="item.isLocked"
                                  @change="
                                    ($event) => handleChangeChildCheckbox({ field, value: $event })
                                  "
                                />
                                {{ $t(item.label) }}
                              </span>
                            </div>
                          </li>
                        </transition-group>
                      </draggable>
                    </template>
                  </li>
                </transition-group>
              </draggable>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import InputTableFilter from '../../components/ModalFilter/components/InputTableFilter'
import { GET_DRIVER_FILTER_ALL } from '@/services/api/master/employees'
import {
  GET_VEHICLE_FILTER_ALL,
  GET_VEHICLE_GROUPS,
  GET_VEHICLE_TYPES,
} from '@/services/api/master/fleet'
import { GET_GEOFENCES_FILTER_ALL } from '@/services/api/master/geofence'
import { NOTIFICATION_LIST_CODES } from '@/services/api/notification/general'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import McCheckbox from '@/components/McCheckbox'
import draggable from 'vuedraggable'
import cloneDeep from 'lodash/cloneDeep'
import intervals from '../../components/ModalFilter/lib/intervals'
import { adas, dms, driverBehavior, general } from '@/router/views/notification/lib/alert-code'
import McAlert from '@/components/McAlert'

export default {
  components: {
    Multiselect,
    InputTableFilter,
    McCheckbox,
    draggable,
    McAlert,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    report: {
      type: Object,
      required: true,
    },
    period: {
      type: String,
      default: '',
    },
    defaultColumnOrder: {
      type: Array,
      required: true,
    },
    max: {
      type: Number,
      required: false,
      default: 0,
    },
    initialFilter: {
      type: Object,
      default: () => ({}),
    },
  },
  apollo: {
    employees: {
      query: GET_DRIVER_FILTER_ALL,
      skip() {
        return !this.isHaveEmployeeField
      },
      variables() {
        return {
          filter: {
            isDriver: true,
            isActive: true,
            orderBy: JSON.stringify({ fullname: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        let drivers = { ...data.employees }
        let driverFilter = this.driverFilter instanceof Map ? this.driverFilter : new Map()
        drivers.employees.forEach((item) => {
          driverFilter.set(item.userId, item.fullname)
        })
        this.$store.commit('report/setMapDriverFilter', driverFilter)
        this.$store.commit('report/updateDriverFilterList', {
          list: drivers.employees,
          loaded: true,
        })
      },
    },
    vehicles: {
      query: GET_VEHICLE_FILTER_ALL,
      skip() {
        return !this.isHaveVehicleField
      },
      variables() {
        return {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: JSON.stringify({ licensePlate: 'asc' }),
            isFromReport: true,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return

        let res = { ...data.vehicles }

        let temp = []
        let mapVehicle = this.vehicleFilter instanceof Map ? this.vehicleFilter : new Map()
        res.vehicles.forEach(function (item, index) {
          temp[index] = {
            vehicleType: item.vehicleType
              ? `${item.vehicleType.manufacturer ?? '-'} / ${item.vehicleType.model ?? '-'} / ${
                  item.vehicleType.type ?? '-'
                } `
              : '-',
            vGroups: item.vehicle2Vgroup,
          }
          mapVehicle.set(item.id, item.licensePlate)
        })

        this.$store.commit('report/setMapVehicleFilter', mapVehicle)
        this.$store.commit('report/updateVehicleFilterList', {
          list: temp,
          loaded: true,
        })
      },
    },
    geofences: {
      query: GET_GEOFENCES_FILTER_ALL,
      skip() {
        return !this.isHaveGeofenceField
      },
      variables() {
        return {
          filter: {
            orderBy: JSON.stringify({ fenceName: 'asc' }),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          let geofences = { ...data.geofences.geofences }
          let geofenceFilter = this.geofenceFilter instanceof Map ? this.geofenceFilter : new Map()
          geofences.data.forEach((item) => {
            geofenceFilter.set(item.geofenceId, item.fenceName)
          })
          this.$store.commit('report/setMapGeofenceFilter', geofenceFilter)
          this.$store.commit('report/updateGeofenceFilterList', {
            list: geofences.data,
            loaded: true,
          })
        }
      },
    },
    vehicleTypes: {
      query: GET_VEHICLE_TYPES,
      skip() {
        return !this.isHaveVehicleField
      },
      variables() {
        return {
          filter: {
            hasVehicle: true,
            isActive: true,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        let vehicleTypes = { ...data.vehicleTypes }
        this.$store.commit('report/updateVehicleTypeList', {
          list: vehicleTypes.vehicleTypes.data,
          loaded: true,
        })
      },
    },
    vgroups: {
      query: GET_VEHICLE_GROUPS,
      skip() {
        return !this.isHaveVehicleField
      },
      result({ data, loading }) {
        if (loading) return
        let vgroups = { ...data.vgroups }
        this.$store.commit('report/updateVgroupList', {
          list: vgroups.vgroups,
          loaded: true,
        })
      },
    },
    alertCodes: {
      query: NOTIFICATION_LIST_CODES,
      skip() {
        return !this.isHaveAlertCodeField
      },
      variables() {
        let alertCodes = [
          12, 1, 10, 2, 11, 8, 4, 5, 19, 20, 13, 14, 15, 16, 21, 22, 23, 24, 25, 26, 75, 17, 18, 3,
        ]
        alertCodes = alertCodes.concat(
          general.reduce((cumm, item) => {
            cumm.push(...item.alertCode)
            return cumm
          }, []),
          driverBehavior.reduce((cumm, item) => {
            cumm.push(...item.alertCode)
            return cumm
          }, [])
        )
        if (this.hasAccess(['e1c-web-dms:read']))
          alertCodes = alertCodes.concat(
            dms.reduce((cumm, item) => {
              cumm.push(...item.alertCode)
              return cumm
            }, [])
          )
        if (this.hasAccess(['e1g-web-adas:read']))
          alertCodes = alertCodes.concat(
            adas.reduce((cumm, item) => {
              cumm.push(...item.alertCode)
              return cumm
            }, [])
          )
        alertCodes = [...new Set(alertCodes)]

        return {
          filter: {
            alertCode: alertCodes,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        let res = Object.assign({}, data)
        let filteredAlert = res.alertCodes.alertCodes
          .filter((x) => x.alertCode != 37 && x.alertCode != 95)
          .map((item) => {
            return Object.assign({}, item, { id: item.alertCode })
          })
        this.$store.commit('report/updateAlertFilterList', {
          list: filteredAlert,
          loaded: true,
        })
      },
    },
  },
  mixins: [Helper],
  data() {
    return {
      excelIcon: require('@/assets/images/download-format/excel.png'),
      pdfIcon: require('@/assets/images/download-format/pdf.png'),
      vehicleData: [],
      driverData: [],
      formValues: {},
      fullObjects: {},
      vehicleTypes: {
        vehicleTypes: [],
      },
      vgroups: {
        vgroups: [],
      },
      employees: {
        employees: [],
      },
      vehicles: {
        vehicles: [],
      },
      geofences: {
        geofences: [],
      },
      alertCodes: {
        alertCodes: [],
      },
      downloadAs: null,
      reportKeyWeekly: ['alert', 'geolocation', 'summary-stopped'],
      reportKeyWeeklyAndOneVehicle: ['detail-history-vehicle', 'fuel'],
      reportKeyWeeklyOrOneVehicle: ['history-vehicle'],
      reportKeyOneVehicle: ['temperature'],
      reportKeyUseChart: ['fuel', 'temperature'],
      filter: {},
      isValidated: false,
      fieldsTemp: [],
      alwaysChecked: true,
      refreshAccordion: true,
      intervalData: {
        fiveMinutes: true,
      },
      interval: intervals,
      filteredGrade: [
        { id: 0, grade: 'A' },
        { id: 1, grade: 'B' },
        { id: 2, grade: 'C' },
        { id: 3, grade: 'D' },
        { id: 4, grade: 'E' },
      ],
      filteredServiceStatus: [
        {
          id: 1,
          status: this.$t('maintenance.status.normal'),
        },
        { id: 2, status: this.$t('maintenance.status.inService') },
        {
          id: 3,
          status: this.$t('maintenance.status.lateService'),
        },
        {
          id: 4,
          status: this.$t('maintenance.status.approachingService'),
        },
      ],
      filteredAcc: [
        { id: 'on', label: this.$t('report.label.on') },
        { id: 'off', label: this.$t('report.label.off') },
      ],
      filteredCondition: [
        { id: 'in', label: this.$t('report.label.in') },
        { id: 'out', label: this.$t('report.label.out') },
      ],
      isLoadFilter: false,
      temperatureKey: ['temperature'],
      fuelKey: ['fuel', 'summary-fuel', 'summary-day-fuel'],
      doorKey: ['door'],
      formFilled: false,
      falseAlert: null,
      reportWithNoFilter: ['offline-vehicle'],
      monthlyReportType: 'monthly',
      weeklyReportType: 'weekly',
      reportType: 'weekly',
      weeklyPeriodKey: 1,
      reportTypeChange: 0,
      isImportant: null,
      formKey: 0,
    }
  },
  watch: {
    async alwaysChecked() {
      await this.$nextTick()
      this.alwaysChecked = true
    },
    fieldsTemp: {
      handler: function (value) {
        this.$emit('columnUpdated', value)
      },
      deep: true,
    },
    formValues: {
      handler: function (value) {
        if (value.vehicleId && value.vehicleId.length > 1 && this.intervalData.all) {
          this.intervalData = { fiveMinutes: true }
        }
        const filter = {
          ...value,
        }
        if (this.downloadAs) {
          filter.downloadAs = this.downloadAs.actualValue
        }
        if (this.hasIntervalFilter) {
          filter.interval = this.intervalFilter
        }
        if (this.hasFalseAlert) {
          filter.isFalseAlert = this.falseAlert === null ? undefined : this.falseAlert
        }
        if (this.hasIsImportantFilter) {
          filter.isImportant = this.isImportant === null ? undefined : this.isImportant
        }
        if (this.hasReportTypeFilter) {
          filter.reportType = this.reportType
        }

        if (filter.alertCode && filter.alertCode.includes(94) && !filter.alertCode.includes(95))
          filter.alertCode.push(95)
        if (filter.alertCode && filter.alertCode.includes(1) && !filter.alertCode.includes(37))
          filter.alertCode.push(37)
        if (filter.alertCode) filter.alertCode = [...new Set(filter.alertCode)]

        const isAllFilterFilled = this.report.filter
          ? Object.keys(this.report.filter)
              .filter((item) => item != 'periode' && this.report.filter[item].required)
              .every(
                (item) => filter[item] && (!Array.isArray(filter[item]) || filter[item].length > 0)
              )
          : true
        if (!this.report.filter || (this.report.filter && isAllFilterFilled)) this.formFilled = true
        else {
          this.formFilled = false
          this.downloadAs = null
        }

        this.filter = filter
        this.$emit('updateFilter', filter)
      },
      deep: true,
    },
    downloadOptions(value) {
      if (
        !value.map((item) => item.actualValue).includes(this.downloadAs?.actualValue) &&
        this.downloadAs
      )
        this.downloadAs = null
    },
    reportType(value) {
      if (value) {
        this.filter.reportType = value
        this.$emit('updateFilter', this.filter)
      }
    },
    downloadAs(value) {
      if (value) {
        this.isValidated = true
        this.filter.downloadAs = value.actualValue
        this.$emit('updateFilter', this.filter)
      }
    },
    intervalData(value) {
      if (this.hasIntervalFilter) {
        this.filter.interval = this.intervalFilter
      }
    },
    falseAlert(value) {
      if (this.hasFalseAlert) {
        this.filter.isFalseAlert = value === null ? undefined : value
      }
    },
    isImportant(value) {
      if (this.hasIsImportantFilter) {
        this.filter.isImportant = value === null ? undefined : value
      }
    },
    period(value) {
      if (
        !this.hasCsvScope &&
        this.finalReport.filter?.vehicleId &&
        this.reportKeyWeeklyOrOneVehicle.includes(this.finalReport.key) &&
        value == 'm' &&
        this.filter?.vehicleId &&
        Array.isArray(this.filter?.vehicleId)
      ) {
        this.formValues.vehicleId = null
        this.fullObjects.vehicleId = []
      } else if (
        !this.hasCsvScope &&
        this.finalReport.filter?.vehicleId &&
        this.reportKeyWeeklyOrOneVehicle.includes(this.finalReport.key) &&
        value != 'm' &&
        this.filter?.vehicleId &&
        !Array.isArray(this.filter?.vehicleId)
      ) {
        this.formValues.vehicleId = null
        this.fullObjects.vehicleId = []
      }
    },
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    isReportTypeRequired() {
      const fieldReportType = this.report.filter?.reportType
      if (fieldReportType) {
        return fieldReportType.required
      }
      return false
    },
    hasIntervalFilter() {
      return (
        this.report.filter &&
        Object.keys(this.report.filter).length > 0 &&
        Object.keys(this.report.filter).includes('interval') &&
        this.hasAccess(['interval_report:read'])
      )
    },
    hasFalseAlert() {
      return (
        this.report.filter &&
        this.report.filter?.falseAlert &&
        this.hasAccess(['false_alert_report:read'])
      )
    },
    hasReportTypeFilter() {
      return (
        this.report.filter &&
        Object.keys(this.report.filter).length > 0 &&
        Object.keys(this.report.filter).includes('reportType')
      )
    },
    hasIsImportantFilter() {
      return (
        this.report.filter &&
        Object.keys(this.report.filter).length > 0 &&
        Object.keys(this.report.filter).includes('isImportant')
      )
    },
    intervalFilter() {
      const keys = Object.keys(this.intervalData)
      return keys[0]
    },
    listInterval() {
      let result = this.interval
      if (Object.keys(this.formValues).length <= 0) return result
      else if (this.formValues.vehicleId && this.formValues.vehicleId.length > 1) {
        result = result.map((item) => {
          if (item.key === 'all') {
            return {
              ...item,
              disabled: true,
            }
          } else {
            return item
          }
        })
        return result
      } else return result
    },
    showAllColumn: {
      get() {
        return this.fieldsTemp.every((field) => field.shown)
      },
      set(value) {
        this.fieldsTemp.forEach((field) => {
          field.shown = value
          if (field.children) {
            field.children.forEach((child) => {
              child.shown = value
            })
          }
        })
      },
    },
    isAnyLocked() {
      return this.defaultColumnOrder.every(
        (field) =>
          field.isLocked || (field.children && field.children.every((child) => child.isLocked))
      )
    },
    stateDownloadAs() {
      return this.downloadAs?.value || !this.isValidated
    },
    finalReport() {
      const report = Object.assign({}, this.report)
      if (this.hasCsvScope && report.filter?.vehicleId) {
        report.filter.vehicleId.value = []
      } else if (this.hasCsvScope && !report.filter?.vehicleId && report.filter?.driverId) {
        report.filter.driverId.value = []
      } else if (
        !this.hasCsvScope &&
        report.filter?.vehicleId &&
        this.reportKeyWeeklyOrOneVehicle.includes(report.key) &&
        this.period == 'm'
      ) {
        report.filter.vehicleId.value = ''
      } else if (
        !this.hasCsvScope &&
        report.filter?.vehicleId &&
        this.reportKeyWeeklyOrOneVehicle.includes(report.key) &&
        this.period != 'm'
      ) {
        report.filter.vehicleId.value = []
      }
      return report
    },
    isHaveEmployeeField() {
      return this.report.filter?.driverId
    },
    isHaveVehicleField() {
      return this.report.filter?.vehicleId
    },
    isHaveGeofenceField() {
      return (
        this.report.filter?.geofenceId ||
        this.report.filter?.garageId ||
        this.report.filter?.startGeofenceId ||
        this.report.filter?.endGeofenceId ||
        this.report.filter?.intersectGeofenceIds
      )
    },
    isHaveAlertCodeField() {
      return this.report.filter?.alertCode
    },
    hasCsvScope() {
      return this.report?.downloadOptions?.includes('csv') && this.hasAccess(['csv_report:read'])
    },
    reportWeeklyValidate() {
      return this.reportKeyWeekly.includes(this.report.key) && this.period != 'm'
    },
    reportOnlyVehicleAndWeeklyValidate() {
      return (
        this.reportKeyWeeklyAndOneVehicle.includes(this.report.key) &&
        this.period != 'm' &&
        (!this.filter?.vehicleId ||
          (Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId?.length <= 1) ||
          (!Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId))
      )
    },
    reportOnlyVehicleValidate() {
      return (
        this.reportKeyOneVehicle.includes(this.report.key) &&
        (!this.filter?.vehicleId ||
          (Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId?.length <= 1) ||
          (!Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId))
      )
    },
    summaryDayValidate() {
      return (
        this.report.key === 'summary-day' &&
        (this.period != 'm' ||
          (this.period === 'm' &&
            (!this.filter?.vehicleId ||
              (Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId?.length <= 100))))
      )
    },
    summaryDayDriverValidate() {
      return (
        this.report.key === 'summary-day-driver' &&
        (this.period != 'm' ||
          (this.period === 'm' &&
            (!this.filter?.driverId ||
              (Array.isArray(this.filter?.driverId) && this.filter?.driverId?.length <= 100))))
      )
    },
    reportKeyWeeklyOrOneVehicleValidate() {
      return (
        this.reportKeyWeeklyOrOneVehicle.includes(this.report.key) &&
        (this.period != 'm' ||
          (this.period === 'm' &&
            (!this.filter?.vehicleId ||
              (Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId?.length <= 1) ||
              (!Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId))))
      )
    },
    chartDocValidate() {
      return (
        this.reportKeyUseChart.includes(this.report.key) &&
        this.period != 'm' &&
        (!this.filter?.vehicleId ||
          (Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId?.length <= 1) ||
          (!Array.isArray(this.filter?.vehicleId) && this.filter?.vehicleId))
      )
    },
    downloadOptions() {
      const result = []
      if (
        (!this.reportKeyWeekly.includes(this.report.key) &&
          !this.reportKeyWeeklyAndOneVehicle.includes(this.report.key) &&
          !this.reportKeyOneVehicle.includes(this.report.key) &&
          !['summary-day', 'summary-day-driver'].includes(this.report.key) &&
          !this.reportKeyWeeklyOrOneVehicle.includes(this.report.key)) ||
        this.reportWeeklyValidate ||
        this.reportOnlyVehicleAndWeeklyValidate ||
        this.reportOnlyVehicleValidate ||
        this.summaryDayValidate ||
        this.summaryDayDriverValidate ||
        this.reportKeyWeeklyOrOneVehicleValidate
      ) {
        result.push(this.generateDocumentObject('TE'), this.generateDocumentObject('TP'))
      }
      if (this.hasCsvScope) {
        result.push(this.generateDocumentObject('TC'))
      }
      if (this.chartDocValidate) {
        result.push(this.generateDocumentObject('GP'))
      }
      return result
    },
  },
  methods: {
    validate(val) {
      this.isValidated = val
    },
    generateDocumentObject(actualValue) {
      switch (actualValue) {
        case 'TE':
          return {
            value: 'xlsx',
            label: this.$t('global.object.excel'),
            icon: 'icon-fill_excel',
            actualValue: 'TE',
          }
        case 'TP':
          return {
            value: 'pdf',
            label: this.$t('global.object.pdf'),
            icon: 'icon-fill_pdf',
            actualValue: 'TP',
          }
        case 'TC':
          return {
            value: 'csv',
            label: this.$t('global.object.csv'),
            icon: 'icon-fill_excel',
            actualValue: 'TC',
          }
        case 'GP':
          return {
            value: 'graph',
            label: this.$t('global.object.graphicPdf'),
            icon: 'icon-fill_pdf',
            actualValue: 'GP',
          }
        default:
          return null
      }
    },
    loadVehicleValue(value, key) {
      let result = {
        formValues: {},
        fullObjects: {},
      }
      if (
        Array.isArray(value[key]) &&
        (Array.isArray(this.report.filter?.vehicleId?.value) || this.hasCsvScope)
      ) {
        result.fullObjects = {
          [key]:
            value[key]
              .map((item) => {
                return this.vehicles.vehicles.find((item2) => item2.id == item)
              })
              .filter((item) => item !== null && item !== undefined) ?? [],
        }
        result.formValues = result.fullObjects[key].map((item) => item.id) ?? null
      } else {
        if (Array.isArray(value[key])) {
          return {
            formValues: null,
            fullObjects: [],
          }
        }
        const vehicle = this.vehicles.vehicles.find((item) => item.id == value[key])
        if (this.hasCsvScope) {
          result.fullObjects = {
            [key]: vehicle ? [vehicle] : [],
          }
          result.formValues = [result.fullObjects[key][0].id] ?? null
        } else {
          result.fullObjects = {
            [key]: vehicle ?? [],
          }
          result.formValues = result.fullObjects[key].id ?? null
        }
      }
      return result
    },
    loadDriverValue(value, key) {
      let result = {
        formValues: {},
        fullObjects: {},
      }
      if (Array.isArray(value[key])) {
        result.fullObjects = {
          [key]:
            value[key]
              .map((item) => {
                const user = this.employees.employees.find((item2) => item2.userId == item)
                return user
                  ? {
                      id: user.userId,
                      fullname: user.fullname,
                    }
                  : null
              })
              .filter((item) => item !== null && item !== undefined) ?? [],
        }
        result.formValues = result.fullObjects[key].map((item) => item.id) ?? null
      } else {
        const user = this.employees.employees.find((item) => item.userId == value[key]) ?? {}
        result.fullObjects = {
          [key]: user.userId
            ? {
                id: user.userId,
                fullname: user.fullname,
              }
            : [],
        }
        result.formValues = result.fullObjects[key].id ?? null
      }
      return result
    },
    loadGeofenceValue(value, key) {
      let result = {
        formValues: {},
        fullObjects: {},
      }
      if (Array.isArray(value[key])) {
        result.fullObjects = {
          [key]:
            value[key]
              .map((item) => {
                const geofence = this.geofences.geofences.find((item2) => item2.geofenceId == item)
                return geofence
                  ? {
                      id: geofence.geofenceId,
                      fenceName: geofence.fenceName,
                    }
                  : null
              })
              .filter((item) => item !== null && item !== undefined) ?? [],
        }
        result.formValues = result.fullObjects[key].map((item) => item.id) ?? null
      } else {
        const geofence =
          this.geofences.geofences.find((item) => item.geofenceId == value[key]) ?? {}
        result.fullObjects = {
          [key]: geofence.geofenceId
            ? {
                id: geofence.geofenceId,
                fenceName: geofence.fenceName,
              }
            : [],
        }
        result.formValues = result.fullObjects[key].id ?? null
      }
      return result
    },
    loadAccValue(value, key) {
      if (Array.isArray(value[key])) {
        return {
          [key]: value[key].map((item) => {
            const acc = this.filteredAcc.find((item2) => item2.id == item)
            return acc
          }),
        }
      } else {
        return {
          [key]: this.filteredAcc.find((item) => item.id == value[key]),
        }
      }
    },
    loadServiceStatusValue(value, key) {
      if (Array.isArray(value[key])) {
        return {
          [key]: value[key].map((item) => {
            const status = this.filteredServiceStatus.find((item2) => item2.id == item)
            return status
          }),
        }
      } else {
        return {
          [key]: this.filteredServiceStatus.find((item) => item.id == value[key]),
        }
      }
    },
    loadConditionValue(value, key) {
      if (Array.isArray(value[key])) {
        return {
          [key]: value[key].map((item) => {
            const condition = this.filteredCondition.find((item2) => item2.id == item)
            return condition
          }),
        }
      } else {
        return {
          [key]: this.filteredCondition.find((item) => item.id == value[key]),
        }
      }
    },
    loadAlertCodeValue(value, key) {
      let result = {
        formValues: {},
        fullObjects: {},
      }
      if (Array.isArray(value[key])) {
        result.fullObjects = {
          [key]:
            value[key]
              .map((item) => {
                const alertCode = this.alertCodes.alertCodes.find(
                  (item2) => item2.alertCode == item
                )
                return alertCode
                  ? {
                      id: alertCode.alertCode,
                      descriptionEng: alertCode.descriptionEng,
                      descriptionIdn: alertCode.descriptionIdn,
                    }
                  : null
              })
              .filter((item) => item !== null && item !== undefined) ?? [],
        }
        result.formValues = result.fullObjects[key].map((item) => item.id) ?? null
      } else {
        const alertCode =
          this.alertCodes.alertCodes.find((item) => item.alertCode == value[key]) ?? {}
        result.fullObjects = {
          [key]: alertCode.alertCode
            ? {
                id: alertCode.alertCode,
                descriptionEng: alertCode.descriptionEng,
                descriptionIdn: alertCode.descriptionIdn,
              }
            : [],
        }
        result.formValues = result.fullObjects[key].id ?? null
      }
      return result
    },
    loadGradeValue(value, key) {
      if (Array.isArray(value[key])) {
        return {
          [key]: value[key].map((item) => {
            const grade = this.filteredGrade.find((item2) => item2.id == item)
            return grade
          }),
        }
      } else {
        return {
          [key]: this.filteredGrade.find((item) => item.id == value[key]),
        }
      }
    },
    async loadData(initialHeader, initialFilter, initialDownloadAs, reportKey) {
      if (initialFilter) {
        await Promise.all([
          this.$apollo.queries.vehicles.refetch(),
          this.$apollo.queries.employees.refetch(),
          this.$apollo.queries.geofences.refetch(),
          this.$apollo.queries.alertCodes.refetch(),
        ])
      }
      let columnOrder = this.defaultColumnOrder
      columnOrder = columnOrder.map((item) => {
        if (item.children) {
          const children = item.children.map((child) => {
            return {
              ...child,
              shown:
                initialHeader != null || initialHeader != undefined
                  ? initialHeader.includes(child.header)
                  : true,
            }
          })
          const childrenShown = children.filter((child) => child.shown)
          return {
            ...item,
            children,
            shown: childrenShown.length == item.children.length,
          }
        } else {
          return {
            ...item,
            shown:
              initialHeader != null || initialHeader != undefined
                ? initialHeader.includes(item.header)
                : true,
          }
        }
      })
      if (initialDownloadAs) {
        this.downloadAs = this.generateDocumentObject(initialDownloadAs)
      }

      if (initialFilter) {
        if (initialFilter.interval) {
          this.intervalData = this.transformFilterInterval(initialFilter.interval)
          initialFilter.interval = undefined
        }

        if (initialFilter.isFalseAlert != undefined) {
          this.falseAlert = initialFilter.isFalseAlert
        }

        if (initialFilter.isImportant != undefined) {
          this.isImportant = initialFilter.isImportant
        }

        if (initialFilter.reportType != undefined) {
          this.reportType = initialFilter.reportType
        }

        this.formValues = { ...initialFilter }
        this.fullObjects = {}
        Object.keys(this.formValues).forEach((key) => {
          let result = {}
          if (key === 'vehicleId') {
            const res = this.loadVehicleValue(this.formValues, key)
            result = res.fullObjects
            this.formValues[key] = res.formValues
          } else if (key === 'driverId') {
            const res = this.loadDriverValue(this.formValues, key)
            result = res.fullObjects
            this.formValues[key] = res.formValues
          } else if (key === 'acc') {
            result = this.loadAccValue(this.formValues, key)
          } else if (key === 'serviceStatus') {
            result = this.loadServiceStatusValue(this.formValues, key)
          } else if (key === 'condition') {
            result = this.loadConditionValue(this.formValues, key)
          } else if (key === 'alertCode') {
            const res = this.loadAlertCodeValue(this.formValues, key)
            result = res.fullObjects
            this.formValues[key] = res.formValues
          } else if (key === 'grade') {
            result = this.loadGradeValue(this.formValues, key)
          } else if (
            key === 'geofenceId' ||
            key === 'startGeofenceId' ||
            key === 'endGeofenceId' ||
            key === 'intersectGeofenceIds' ||
            key === 'garageId'
          ) {
            const res = this.loadGeofenceValue(this.formValues, key)
            result = res.fullObjects
            this.formValues[key] = res.formValues
          }
          this.fullObjects = {
            ...this.fullObjects,
            ...result,
          }
        })
      }
      this.fieldsTemp = cloneDeep(columnOrder)
      if (!initialFilter && this.downloadAs) {
        const filter = {
          downloadAs: this.downloadAs.actualValue,
        }
        this.$emit('updateFilter', filter)
      }
      if (reportKey && this.reportWithNoFilter.includes(reportKey)) {
        this.formFilled = true
      } else {
        this.formFilled = false
      }
      this.isLoadFilter = true
    },
    keyChanged(oldKey, newKey) {
      if (oldKey !== newKey) {
        if (this.reportWithNoFilter.includes(newKey)) {
          this.formFilled = true
        } else {
          this.formFilled = false
        }
        this.formKey += 1
        this.resetForm()
      }
    },
    handleResetColumn() {
      this.fieldsTemp = cloneDeep(this.defaultColumnOrder)
    },
    handleChangeCheckAll(value) {
      this.fieldsTemp = this.fieldsTemp.map((field) => {
        if (field.children) {
          field.children = field.children.map((subField) => ({
            ...subField,
            shown: value,
          }))
        }

        return {
          ...field,
          shown: field.isLocked ? true : value,
        }
      })
    },
    handleChangeParentCheckbox({ field, value }) {
      if (!field.children) return

      field.children.forEach((item) => {
        item.shown = value
      })
    },
    handleChangeChildCheckbox({ field, value }) {
      if (field.shown == value) return

      let totalCount = 0

      field.children.forEach((item) => {
        if (item.shown !== value) return

        totalCount++
      })

      if (value === false && totalCount !== field.children.length) return

      field.shown = value
    },
    hideChildren(field) {
      if (field.closeChild == undefined) field.closeChild = false

      this.refreshAccordion = false

      setTimeout(() => {
        field.closeChild = !field.closeChild
        this.refreshAccordion = true
      }, 50)
    },
    disabledCheck(field) {
      if (!this.max && !field.isLocked) return false

      const checked = this.fieldsTemp.filter((x) => x.shown).map((x) => x.key)
      return (
        this.max &&
        (field.isLocked || (checked.length === this.max && !checked.includes(field.key)))
      )
    },
    updateFormValues({ key, value }) {
      this.$set(this.formValues, key, value)
    },
    updateFullObjects({ key, value }) {
      this.$set(this.fullObjects, key, value)
    },
    resetForm() {
      this.formValues = {}
      this.fullObjects = {}
      this.intervalData = {
        fiveMinutes: true,
      }
      this.downloadAs = null
      this.isValidated = false
    },

    transformFilterInterval(interval) {
      const intervalData = {}
      intervalData[interval] = true
      return intervalData
    },

    filterIntervalData(interval) {
      this.intervalData = {}
      this.intervalData[interval] = true
    },
  },
}
</script>
<style lang="scss" scoped>
.mc-filter-report-scheduler {
  background-color: var(--Additional-Light-Blue, rgba(231, 236, 244, 1));
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  height: 100%;
}
:deep(.table-view-manager) {
  .wrapper {
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}

.section {
  :deep(input[type='checkbox']) {
    margin-bottom: 2px;
  }

  & > p {
    color: $teal-300;
    font-weight: 600;
  }

  &-information {
    &__content {
      border: 2px solid $blue-100;
      border-radius: 4px;
      margin-bottom: 20px;

      & > p {
        display: flex;
        gap: 5px;
        align-items: center;
        margin-bottom: 0;

        &:first-child {
          margin-bottom: 4px;
        }
      }
    }
  }

  &-column-manager {
    overflow: hidden;
    flex: 1 1 auto;

    &__content {
      box-shadow: 0px 5px 15px 0px rgba(13, 68, 145, 0.08);
      overflow-y: hidden;
      height: 100%;
    }

    &__header {
      button {
        background: transparent;
        border: none;
        color: $cyan;
        font-weight: 600;
      }
    }

    &__draggable {
      background: $gray;
      padding: 16px;
      overflow-y: auto;
      height: 100%;
      padding-bottom: 86px;

      ul {
        padding: 0;
      }

      &-item,
      &-sub-item {
        list-style-type: none;
        cursor: move;
        background: white;
        margin-bottom: 16px;
        border-radius: 5px;
        padding: 14px 12px;
        transition: 0.3s;

        .__divider {
          background-color: $teal-100;
          height: 16px;
          width: 1px;
        }

        .toggle-list {
          font-size: 20px;

          &::before {
            color: #3d69a7;
          }
        }
      }

      &-sub-item {
        list-style-type: none;
        border: 1px solid #cfdae9;
      }
    }
  }
}

.icon-outline_move {
  color: $blue-400;
  font-size: 16px;
}

.mc-hover-pointer {
  &:hover {
    cursor: pointer !important;
  }
}
</style>
